jQuery(document).ready(function () {
  Main.init();

  jQuery(".datepicker").datepicker({
    format: "dd/mm/yyyy",
    language: "pt-BR",
  });

  jQuery("[data-mask-money]").priceFormat({
    prefix: "",
    thousandsSeparator: "",
  });

  jQuery("[data-print]").on("click", function (e) {
    e.preventDefault();
    window.print();
  });

  jQuery("[data-stacktable]").stacktable();

  var user_role = $('[name="user[role]"]'),
    toggle_supplier = $("[data-toggle-supplier]");

  function checkRole() {
    var checked = user_role.filter(":checked").val();

    if (checked === "supplier") {
      toggle_supplier.show();
    } else {
      toggle_supplier.hide();
    }
  }

  user_role.on("click", function () {
    checkRole();
  });

  checkRole();
});
